export default __webpack_public_path__ + "static/learn-to-swim-f7124c6fd3ff6353dc51bd7e3ef96378.svg";